import React, {Component} from 'react';
import 'date-fns';
import {CssBaseline, Typography, IconButton, Dialog,withStyles, Button} from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import {isMobileOnly, CustomView} from 'react-device-detect';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TextsmsIcon from '@material-ui/icons/Textsms';
import FacebookIcon from '@material-ui/icons/Facebook';
import Tooltip from '@material-ui/core/Tooltip';

const textSize1 = () =>{
    if (isMobileOnly) return 'h5'
    else return 'h4'
  }
  
  const textSize2 = () =>{
    if (isMobileOnly) return 'h7'
    else return 'h7'
  }

 const buttonSize = () => {
   if (isMobileOnly) return 'small'
   else return 'medium'
 }

  const customWidth = () => {
    if (isMobileOnly) return {minWidth: '30vw'}
    else return {maxWidth: '8vw'}
  }

  const contactWidth = () => {
    let returnWidth = 0

    if (isMobileOnly) returnWidth = customWidth() /2
    else returnWidth = customWidth() /3

    return {maxWidth: returnWidth}
  }
  const spanRender = () => {
    if (isMobileOnly) return '2'
    else return '2'
  }

  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    
  });

  const useStyles = makeStyles({
  
      ContentBackground:{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#282c34',
        height: '80vh',
        overflow: 'auto',
        display: 'flex',
        width:'100vw',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },

      containerStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        display: 'flex',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },
  
      title: {
        marginTop: '2vh',
        marginLeft: '2vw',
        color: 'black',
        display: 'flex',
        fontFamily:'Roboto',
        fontStyle: 'oblique',
        fontWeight: 'bold'
      },
  
  
      inputCenter: {
        textAlign: "center",
        color: "red"
      }
    });

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  
const DialogContent = withStyles(theme => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

export default function HistoryView({fire}){
    const styleClasses = useStyles();
    const [dialogCont,setCont] = React.useState([])
    const [open,setOpen] = React.useState(false)
    const numberOrder = localStorage.getItem('numberOrder') || 0;
    
    
class OrderView extends Component  {
  constructor() {
    super();
    
  this.state = {
    historyList: [],
    contactList: []
  };
  }
  componentDidMount() {
    const orderRef = fire.database().ref('UserOrder');
    orderRef.on('value',(snapshot) =>{
      let histoRecord = [];
      let newState = [];
      let items = snapshot.val();
      for (let i = 0; i <= parseInt(numberOrder) ; i++){
        const name = localStorage.getItem(`orderName_${i}`) || '';
        const orderTime = localStorage.getItem(`orderTime__${i}`) || '';
        for (let item in items) {
            if (items[item].orderTime === orderTime && items[item].name === name){histoRecord.push(items[item])}
      }}

      fire.database().ref('SellerLogin').once('value', (shot) =>{
        let shotVals = shot.val();
        for (let histoElements in histoRecord) {
          for (let histoElement in histoRecord[histoElements]['order']){
            for (let shotVal in shotVals) { 
                if (shotVals[shotVal].Name === histoElement) //This might cause conflict if shops have same name
                { newState.push({
                  Name: histoElement,
                  Contact: shotVals[shotVal].PhoneNo,
                  Messenger: shotVals[shotVal].Messenger
                })
                break;
                }
            }
          }
        }
      });

      this.setState({historyList: histoRecord , contactList: newState})
    
    });

   // fire.database().ref('Shop/1').once('value',(snapshot) => {
     //  let item = snapshot.val().Menu;
       //fire.database().ref('Shop/0').update({Menu: item})
      //  for (let item in items['Shared']){
      //    fire.database().ref(`Seller/${items['Shared'][item]}/9/Method/Pick-up`).update({Description: "Pick up at 2 Edward ct, Mansfield Park 5012"})
          //fire.database().ref(`Seller/${items['Shared'][item]}`).once('value', (captshot) => {
            //let elements = captshot.val();
            //for (let element in elements) {
              //if (elements[element].Name === items.Name){
                //fire.database().ref(`Seller/${items['Shared'][item]}/${element}`).update({Shared: items.Shared})
              //}
            //}
          //})
          //fire.database().ref(`Seller/${items['Shared'][item]}/1`).update({Open: items.Open})
          //fire.database().ref(`Seller/${items['Shared'][item]}/1`).update({Shared: items.Shared})
          //fire.database().ref(`Seller/${items['Shared'][item]}/1`).update({Menu: snapshot.val().Menu})
          //fire.database().ref(`Seller/CBD/1`).update({Menu: snapshot.val().Menu})
          //fire.database().ref(`Seller/Regency Park/1`).update({AvailableDay: snapshot.val().AvailableDay})
          //fire.database().ref(`Seller/Regency Park/1`).update({Name: snapshot.val().Name})
          //fire.database().ref(`Seller/Regency Park/1`).update({Logo: snapshot.val().Logo})
          //fire.database().ref(`Seller/Regency Park/1`).update({Description: snapshot.val().Description})
          //fire.database().ref(`Seller/Regency Park/1`).update({Method: snapshot.val().Method})
          //fire.database().ref(`Seller/Regency Park/1`).update({Shared: snapshot.val().Shared})
      //  }
   // })

    //  fire.database().ref('UserOrder').once('value', (snapshot) => {
    //    let items = snapshot.val();
    //    let i = 0;
    //    let j = 0;
    //    let z = 0;
    //    for (let item in items) {
    //      i = i+1; 
    //      for (let shop in items[item]['order']){
    //        if (items[item]['order'][shop].status === 'Cancelled') z = z+1;
    //        if (items[item]['order'][shop].status !== 'Cancelled') j =j+Number(items[item].total);
    //      }
    //    }
    //    console.log(`Number of orders is ${i}`)
    //    console.log(`Total cancelled order is ${z}`)
    //    console.log(`Total sale is ${j}`)
    //  })
  }

  minusNo = (arg1, arg2) => { 
    if ('Promo' in arg2) {
      if (arg1) return 7
      else return 5
    }
    else {
      if (arg1) return 6
      else return 4
    }
  }

  whatTotal = (arg, fee) => {
    if (arg.status !== 'Cancelled') {
      return (Number(arg.shopTotal) + Number(fee) - Number(arg.Promo)).toFixed(2)
    }
    else return (0).toFixed(2)
  }

    handleClickOpen = (name1, time, name2) => event => {
        event.preventDefault();
        const index = this.state.historyList.findIndex(item => item.name === name1 && item.orderTime === time)
        const maxValue = Object.keys(this.state.historyList[index]['order'][name2]).length - this.minusNo(this.state.historyList[index]['order'][name2]['Shipper'], this.state.historyList[index]['order'][name2]);
        let newState = []
        for (let i = 0; i< maxValue; i++){
            newState.push(this.state.historyList[index]['order'][name2][i])
        }
        setCont(newState)
        setOpen(true)
    }

    onCancel = (name1,time,name2) => event => {
        event.preventDefault();
        let keyID = '';
        const index1 = this.state.historyList.findIndex(item => item.name === name1 && item.orderTime === time);
        const index2 = this.state.historyList[index1]['collect'].findIndex(arg => arg.name === name2)
        const dataRef = fire.database().ref('UserOrder');
        dataRef.orderByChild('name').equalTo(name1).once('value',(snapshot) =>{
            let items = snapshot.val();
            for (let item in items) {
                if (items[item].orderTime === time) keyID = item
            }
        })
        const newTotal = Number(this.state.historyList[index1].total) - Number(this.state.historyList[index1]['collect'][index2].fee) - Number(this.state.historyList[index1]['order'][name2].shopTotal) + Number(this.state.historyList[index1].discount);
        const maxValue = Object.keys(this.state.historyList[index1]['order'][name2]).length - this.minusNo(this.state.historyList[index1]['order'][name2]['Shipper'], this.state.historyList[index1]['order'][name2]); 
        const sellerID = this.state.historyList[index1]['order'][name2][0].SellerID
        fire.database().ref(`UserOrder/${keyID}/order/${name2}`).update({status: 'Cancelled',shopTotal: (0).toFixed(2)}) ;
        fire.database().ref(`UserOrder/${keyID}`).update({total: newTotal.toFixed(2)});
        for (let i = 0; i< maxValue; i++){
          fire.database().ref(`Shop/${sellerID}/Menu/${this.state.historyList[index1]['order'][name2][i].ItemKey}`).once('value', (snapshot) => {
            let itemKey = this.state.historyList[index1]['order'][name2][i].ItemKey
            let newValue = Number(snapshot.val().Available) + Number(this.state.historyList[index1]['order'][name2][i].Amount);
            fire.database().ref(`Shop/${sellerID}/Menu/${itemKey}`).update({Available: newValue})

          })
        }    
    }

   onRemove = (name1,time) => event => {
      event.preventDefault();
    //  if (this.state.historyList.length === 1) setEmpty(false);
      let histoRecord = this.state.historyList
      const target = histoRecord.findIndex(arg => arg.orderTime === time && arg.name === name1);
      const numberOrder = localStorage.getItem('numberOrder') || 0;
      for (let i = 0; i <= parseInt(numberOrder) ; i++){
        const localName = localStorage.getItem(`orderName_${i}`) || '';
        const localTime = localStorage.getItem(`orderTime__${i}`) || '';
        if (localName === name1 && localTime === time) {
          localStorage.removeItem(`orderName_${i}`)
          localStorage.removeItem(`orderTime__${i}`)
        }
      }
      histoRecord.splice(target,1);
    if (histoRecord.length !== 0) {this.setState({historyList: histoRecord})}
    else {
      localStorage.removeItem('numberOrder')
      this.setState({historyList: []})
    }
    }

    handleClose = () => setOpen(false)

  render() { 
    return(
      <div >
        <CustomView condition = {(this.state.historyList) && this.state.historyList.length !== 0}>
        { this.state.historyList.map(items => (
        <div>
          <div style ={{backgroundColor: 'lightgray'}}>
            <Typography className={styleClasses.title} variant= {textSize2()} noWrap>
                {items.name} on {(new Date(items.orderTime)).toDateString()}
            </Typography>
          </div>
          <TableContainer component={Paper}>
          <Table aria-label="simple table">
          <TableHead>
          <TableRow>
            <TableCell style={contactWidth()}>Seller</TableCell>
            <TableCell align="center" style={contactWidth()}>Contact</TableCell>
            <TableCell>Collect</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Subtotal</TableCell>
            <TableCell align="center">
                <Button size = {buttonSize()} color="primary"  onClick={this.onRemove(items.name,items.orderTime)}>Remove</Button>
            </TableCell>
            <TableCell />
          </TableRow>
          </TableHead>
        <TableBody>
        {items.collect.map(item => (
            <TableRow key={item.name}>
            <TableCell style={contactWidth()}>            
              {item.name}
            </TableCell>
            <TableCell align="center" style={contactWidth()}>
              <Tooltip title='SMS'>
                <IconButton onClick = { event => {event.preventDefault(); if (isMobileOnly) { 
                if (items['order'][item.name].status !== 'On The Way') {
                  for (let elements in this.state.contactList){
                    if (this.state.contactList[elements].Name === item.name) {
                      if(navigator.userAgent.match(/Android/i)) {
                        window.open(`sms:${this.state.contactList[elements].Contact}/?body=Send a message to shop "${item.name}"`,'_blank')
                      }
        
                      if(navigator.userAgent.match(/iPhone/i)) {
                        window.open(`sms:${this.state.contactList[elements].Contact}&body=Send a message to shop "${item.name}"`,'_blank')
                      }
                      break;
                    }
                  }
                }
                else {
                  if (items['order'][item.name].ShipperPhone){
                    if(navigator.userAgent.match(/Android/i)) {
                      window.open(`sms:${items['order'][item.name].ShipperPhone}/?body=Say something to shipper ${items['order'][item.name].Shipper}`,'_blank')
                    }
        
                    if(navigator.userAgent.match(/iPhone/i)) {
                      window.open(`sms:${items['order'][item.name].ShipperPhone}&body=Say something to shipper ${items['order'][item.name].Shipper}`,'_blank')
                    }
                  }
                }
              }}} >
                  <TextsmsIcon color= 'primary'/>
                </IconButton>
              </Tooltip>
              {' '}
              <Tooltip title ='Messenger'>
                <IconButton>
                  <FacebookIcon
                  onClick = { event => {event.preventDefault(); 
                    for (let elements in this.state.contactList){
                      if (this.state.contactList[elements].Name === item.name && this.state.contactList[elements].Messenger) {
                       window.open(`${this.state.contactList[elements].Messenger}`,"window name"); 
                      }
                    }
                  return false}}
                  color = 'primary'
                />
                </IconButton>
              </Tooltip>
            </TableCell>
            <TableCell style = {customWidth()}>
                {item.description}
            </TableCell>
            <TableCell >
                {items['order'][item.name].status}
            </TableCell>
            <TableCell align="right">
                ${this.whatTotal(items['order'][item.name], item.fee)}
            </TableCell>
            <TableCell align="center">
                <Button size = {buttonSize()} color="primary"  onClick={this.handleClickOpen(items.name,items.orderTime,item.name)}>Detail</Button>
            </TableCell>
            <TableCell align='center'>
                <Button disabled={items['order'][item.name].status !== 'Pending'} size = {buttonSize()} onClick={this.onCancel(items.name,items.orderTime,item.name)} color="secondary">Cancel</Button>
            </TableCell>
            </TableRow>
        ))}
        <TableRow>
            <TableCell align ="left" colSpan={spanRender()}/>
              
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Total:
            </Typography>
            </TableCell>
            <TableCell>
            <Typography variant='h6' style={{color: 'goldenrod', fontWeight: 'bold'}}>
                {items.total}
            </Typography>
            </TableCell>
          </TableRow>
         </TableBody>
      </Table>
    </TableContainer>
    <p></p>
    </div>
    ))}
    <Dialog fullScreen={isMobileOnly} onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title" onClose={this.handleClose}></DialogTitle>
            <DialogContent >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Snack</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="right">Subtotal</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {dialogCont.map(item => (
            <TableRow key={item.name} style={{ overflow: 'auto'}}>
            <TableCell>
                <img style ={{height: '8vh'}} src = {item.ImageLink} alt = {item.name}/>
            </TableCell>
            <TableCell >
                {item.Name}
            </TableCell>
            <TableCell align="center">
                {item.Amount}
            </TableCell>
              <TableCell  align="right">
              <Typography>
                ${Number(item.Total).toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>
            ))}
                </TableBody>
                </Table>
            </TableContainer>
            </DialogContent>
        </Dialog>
            </CustomView>
    <CustomView condition = {this.state.historyList.length === 0} >
        <div className = {styleClasses.containerStyle}>
            <Typography variant={textSize1()}>
                No order history found
            </Typography>
        </div>
    </CustomView>
    <CssBaseline/>
    </div>
    )};
}
 
return <OrderView />
}